<template>
  <div>
    <h1>styling</h1>
  </div>
</template>
<script>
export default {
  name: "Styling",
  data() {
    return {};
  },
};
</script>